@if (widgetModel$ | async; as widgetModel) {
    @if (widgetModel.top.length) {
        <ms-widget-slot
            class="col-12"
            msAutomation="widget-slot-top"
            [page]="page"
            [widget]="widgetModel.top"
            [layoutTemplate]="layoutTemplate"
            [ratio]="1" />
    }
    @if (leftVisible) {
        <ms-widget-slot
            class="col-3"
            msAutomation="widget-slot-left"
            [page]="page"
            [widget]="widgetModel.left"
            [ratio]="3 / 12"
            [layoutTemplate]="layoutTemplate" />
    }
    @if (widgetModel.center.length) {
        <ms-widget-slot
            msAutomation="widget-slot-center"
            [ngClass]="leftVisible ? 'col-9' : 'col-12'"
            [ratio]="leftVisible ? 9 / 12 : 1"
            [page]="page"
            [widget]="widgetModel.center"
            [layoutTemplate]="layoutTemplate" />
    }
}
